import React from "react";

const LoadingSpinner = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#fff9e9",
      }}
    >
      <div
        style={{
          padding: "20px",
          borderRadius: "10px",
          backgroundColor: "white",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "40px",
            height: "40px",
            margin: "0 auto",
            border: "4px solid #f3f3f3",
            borderTop: "4px solid #9CDAED",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
        <p
          style={{
            marginTop: "10px",
            color: "#666",
            fontFamily: "'Inter', sans-serif",
          }}
        >
          Loading...
        </p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
